import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { Link, LinkProps } from 'react-router';

export const LinkTableStyled = styled(Link)<LinkProps>({
  cursor: 'pointer',
  color: '#187787',
  textDecoration: 'none',
  fontWeight: 600,
});

export const BaseVerticalDivider = styled('div')(({ theme }) => ({
  width: '1px',
  backgroundColor: theme.palette.custom.lightGray,
  margin: '0 10px',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const DivVerticalDividerLarge = styled(BaseVerticalDivider)(({ theme }) => ({
  height: '26px',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const DivVerticalDividerSmall = styled(BaseVerticalDivider)({
  height: '23px',
});

export const TypographyPropertiesTitleStyled = styled(Typography)({
  color: '#112233',
  fontSize: '9px',
  fontWeight: 'bold',
});

export const TypographyPropertiesDataStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.darkBlue,
  fontWeight: 'bold',
  fontSize: '11px',
  display: 'flex',
  alignItems: 'center',
  a: {
    color: theme.palette.custom.darkBlue,
    textDecoration: 'none',
  },
}));

interface DivFlexHeaderProps {
  noMargin?: boolean;
}

export const DivFlexHeader = styled('div')<DivFlexHeaderProps>(({ theme, noMargin }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  justifyItems: 'center',
  flexWrap: 'wrap',
  gap: '12px',
  ...(noMargin ? {} : { marginBottom: '15px' }),
  [theme.breakpoints.down('md')]: {
    justifyContent: 'flex-start',
  },
}));

export const DivFlexHeaderIcons = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
  [theme.breakpoints.down('md')]: {
    gap: '12px 8px',
    justifyContent: 'flex-start',
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '16px 12px',
  },
}));
